module.exports = __webpack_public_path__ + "static/media/dot_5117EE.4eff55a5.svg";